<template>
    <div v-if="show" class="mask">
      <div class="share-show flex flex-col">
        <div class="flex flex-space-between full-width">
            <div class="font-bold">分享</div>
            <div class="pointer" @click="close"><img class="logo-22" src="@/assets/images/guanbi.png"/></div>
        </div>
        <div class="flex flex-space-between flex-center-cz margin-top-m">
            <div>开启链接，使用链接或二维码均可分享</div>
            <my-switch v-model="data.openShare" @change="kgChange"></my-switch>
        </div>
        <div class="flex flex-space-between flex-center-cz">
            <div><span>开启访问密码，开启密码才能访问</span>
                <input class="h25 border-radius-ms border w80 margin-left-s" type="text" v-model="data.pwCode" @blur="inputChange"/> 
            </div>
            <my-switch v-model="data.wantPassword" @change="kgChange"></my-switch>
        </div>
        <div class="flex flex-space-between flex-center-cz">
            <div><span>开启访问有效期</span>
                <input class="h25 border-radius-ms border w80 margin-left-s" type="text" v-model="data.days" @blur="inputChange"/> <span>天</span> 
            </div>
            <my-switch v-model="data.openDays" @change="kgChange"></my-switch>
        </div>
        <div class="flex flex-space-between flex-center-cz margin-top-s">
            <div><span>开启允许查看次数</span>
                <input class="h25 border-radius-ms border w80 margin-left-s" type="text" v-model="data.times" @blur="inputChange"/> <span>次</span> 
            </div>
            <my-switch v-model="data.openTimes" @change="kgChange"></my-switch>
        </div>
        <div class="flex flex-space-between flex-center-cz">
            <div>开启允许读者评论</div>
            <my-switch  v-model="data.canComment" @change="kgChange"></my-switch>
        </div>
        <div class="flex flex-space-between flex-center-cz margin-top-m">
            <input class="h25 border-radius-ms border" type="text" :value="data.shareUrl" style="width: 330px;" readonly/>
            <div class="btn-blue-full h25 border-radius-l" 
                v-clipboard:error="onError"  v-clipboard:copy="data.copyText"  v-clipboard:success="onCopy" >复制链接</div>
        </div>
        <div class="flex flex-center-sp margin-top-xl">
            <img  style="width: 150px;height: 150px;" :src="data.shareImgUrl"/>
        </div>
        <div class="flex flex-center-sp margin-top-xl">
          <div>使用微信、QQ等APP扫码分享</div>
        </div>

      </div>
    </div>
  </template>
   
  <script>
  
  import MySwitch from '@/components/switch/Switch.vue'
  import {getShareToken} from '@/utils/sysUtils'
  import {editDocShare} from '@/api/api.js';

  export default {
      name: 'Share',
      components: {MySwitch},
      props: {
          data: {},
          show: {},
      },

      data() {
          return {
            shareToken: getShareToken(6)
          }
      },
  
      methods: {
        close() {
            this.$emit("close");
        },
        inputChange(event) {
            console.log("inputChange", this.data);
            this.$emit("change", this.data);
            this.update(); 

        },
        kgChange(val) {
            console.log('kg', val)
            console.log("data", this.data);
            this.update(); 
            this.$emit("change", this.data);

        },
        update() {
            editDocShare(this.data).then(res=> {
                console.log(res);
            })
        },
        onError(e){

        },
        onCopy(e){
            this.$showToast({msg: '复制成功' });

        },
      }
  }
  </script>
  
  <style scoped>
      .share-show {
          border-radius: 5px;
          width: 450px;
          height: 500px;
          background-color: #fff;
          padding: 20px;
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          margin: auto;
      }
  </style>
  


// WEBPACK FOOTER //
// src/modules/share/Share.vue